import StatusBox from "./Elements/StatusBox";

interface StatusDescription {
    desc: string;
    statusType: "primary" | "success" | "warning" | "error";
}

function getStatusDescription(status: boolean): StatusDescription {
    switch (status) {
        case true:
            return {
                desc: "Aktif",
                statusType: "success"
            }
        case false:
            return {
                desc: "Pasif",
                statusType: "warning"
            }
        default:
            return {
                desc: "Bilinmiyor",
                statusType: "error"
            }
    }
}

export function getStatusInfo(status: boolean) {
    var { desc, statusType } = getStatusDescription(status);
    return <StatusBox content={desc} statusType={statusType} />
}